<template>
	<div class="u-full-height">
		<LoginForm />
	</div>
</template>

<script>
import LoginForm from '@/components/Login/LoginForm';

export default {
	components: {
		LoginForm,
	},
};
</script>
